"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransparentButton = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = require("./Box");
var typography_1 = require("./typography");
function TransparentButton(_a) {
    var label = _a.label, onClick = _a.onClick, color = _a.color;
    return (react_1.default.createElement(Box_1.Box.Button, { border: color, borderRadius: '$2px', onClick: onClick, spaceHorz: '$8px', spaceVert: '$2px', width: '$fitContent' },
        react_1.default.createElement(typography_1.Text, { color: color, size: '$12px', weight: 'medium' }, label)));
}
exports.TransparentButton = TransparentButton;
